import { h } from "preact";
import Required from "./Required";
import Description from "./Description";

const InputField = ({
  input,
  label,
  description,
  inputType,
  required,
  placeholder,
  type,
  disabled,
  style,
  inputStyle,
  autocomplete,
  autofocus = false,
  meta: { touched, error, warning }
}) => {
  inputType = inputType ? inputType : type;
  let invalidObj = {};
  if (required) {
    invalidObj = {
      "aria-invalid": error && touched ? "true" : "false"
    };
  }
  return (
    <div
      class={touched && error ? "form-group has-error" : "form-group"}
      style={style}
    >
      {label ? (
        <label for={input.name} class="form-label">
          <Required required={required} />
          {label}
        </label>
      ) : (
        ""
      )}
      <Description description={description} />
      <input
        class="form-input"
        id={input.name}
        disabled={disabled}
        {...input}
        type={inputType}
        placeholder={placeholder}
        autocomplete={autocomplete}
        style={inputStyle}
        {...invalidObj}
        aria-required={required ? "true" : "false"}
        autofocus={autofocus}
        aria-describedby={`${input.name}Error`}
      />
      {touched && error && (
        <p class="form-input-hint" id={`${input.name}Error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./components/fields/InputField.js